export default "__VITE_ASSET__f1Osxexm__"